"use strict";

var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };

var _react = require("react");

var React = _interopRequire(_react);

var cloneElement = _react.cloneElement;

var ValidComponentChildren = _interopRequire(require("./utils/ValidComponentChildren"));

var ListGroup = React.createClass({
  displayName: "ListGroup",

  propTypes: {
    onClick: React.PropTypes.func
  },

  render: function render() {
    return React.createElement(
      "div",
      { className: "list-group" },
      ValidComponentChildren.map(this.props.children, this.renderListItem)
    );
  },

  renderListItem: function renderListItem(child, index) {
    return cloneElement(child, {
      key: child.key ? child.key : index
    });
  }
});

module.exports = ListGroup;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/ListGroup.js
 ** module id = 125
 ** module chunks = 0
 **/